/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtUpdateRewardDuration = {
  pool: Address;
  rewardIndex: number;
  oldRewardDuration: bigint;
  newRewardDuration: bigint;
};

export type EvtUpdateRewardDurationArgs = {
  pool: Address;
  rewardIndex: number;
  oldRewardDuration: number | bigint;
  newRewardDuration: number | bigint;
};

export function getEvtUpdateRewardDurationEncoder(): FixedSizeEncoder<EvtUpdateRewardDurationArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["rewardIndex", getU8Encoder()],
    ["oldRewardDuration", getU64Encoder()],
    ["newRewardDuration", getU64Encoder()],
  ]);
}

export function getEvtUpdateRewardDurationDecoder(): FixedSizeDecoder<EvtUpdateRewardDuration> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["rewardIndex", getU8Decoder()],
    ["oldRewardDuration", getU64Decoder()],
    ["newRewardDuration", getU64Decoder()],
  ]);
}

export function getEvtUpdateRewardDurationCodec(): FixedSizeCodec<
  EvtUpdateRewardDurationArgs,
  EvtUpdateRewardDuration
> {
  return combineCodec(
    getEvtUpdateRewardDurationEncoder(),
    getEvtUpdateRewardDurationDecoder(),
  );
}
